/* Petifo · Fullscreen lightbox EXTRAS — zoom, arrow keys, back button,
   a findable close button, and the video slide fixes.

   WHY A SEPARATE FILE. assets/pf-zoom-fullscreen.js is ~17KB and already owns
   the horizontal carousel, tap-to-close and swipe-to-dismiss. Every edit there
   means re-uploading the whole file through themeFilesUpsert, which has
   silently truncated payloads at that size. These features are additive, so
   they live here and COOPERATE with that file instead of editing it: this file
   binds on `document` in the CAPTURE phase, which runs BEFORE listeners on a
   descendant, so while the image is zoomed we stopPropagation() and the other
   file's handlers never fire.

   ---------------------------------------------------------------------------
   THE CLOSE BUTTON IS BLENDED, NOT COLOURED. The theme sets
   `mix-blend-mode: difference` on .close-button so a plain glyph stays legible
   on any photo. That INVERTS whatever you paint: a brand-green #064D45 disc
   came out PINK against the cream backdrop and a white ring came out black
   (Peji: "nej gor den inte rosa sa, jattefult"). getComputedStyle still
   reported `rgb(6, 77, 69)`, so the styles were right and the blend was the
   liar — always check mix-blend-mode before believing a colour bug is a
   specificity bug. Fix: `mix-blend-mode: normal !important` + `isolation`.
   Design is now a light-grey disc with a hairline ring and a dark-grey glyph.

   VIDEO SLIDES, TWO SEPARATE FAULTS:
   1. WIDTH. The theme sizes lightbox media by HEIGHT
      (`.product-media-container.constrain-height`), so a slide's WIDTH follows
      the media's aspect ratio. Image slides are pinned to 100%, but a landscape
      video at full viewport height is far wider than the screen and therefore
      occupies several scroll-snap stops — "only half the video shows, scroll
      again and you land on the other half". Forcing `flex:0 0 100%` on every
      direct child plus `object-fit:contain` inside gives one slide = one
      screen at any ratio. NOTE a SQUARE video hides this; test with a
      landscape one.
   2. THE POSTER NEVER LOADS. Shopify's generated preview
      (`...thumbnail.0000000000.jpg`) returned `complete:false, naturalWidth:0`,
      so the slide rendered as an empty box with a lone play triangle — which
      reads as "the video is missing" even though the slide is reachable.
      activateVideo() therefore loads the REAL media as soon as the video slide
      becomes the current one, and hides the dead poster. It loads muted and
      PAUSED with controls — never autoplay with sound in a lightbox.
   ---------------------------------------------------------------------------

   ZOOM: pinch 1x-4x (midpoint stays under the fingers); double-tap /
   double-click toggles 1x <-> 2.5x anchored on the point hit; one finger pans,
   clamped. SUSPENDING THE CAROUSEL WHILE ZOOMED MUST USE INLINE STYLES — a
   stylesheet `!important` rule loses here (measured: the gallery still computed
   `overflow-x: auto`), same lesson as the sticky add-to-cart bar. Zoom resets
   on close and on every slide change.

   ARROW KEYS: Left/Right move one slide, assigning scrollLeft ONCE —
   scroll-snap-type x mandatory snaps every intermediate frame back.

   BACK BUTTON: a phone user reflexively presses Back to close an overlay;
   without this it leaves the product page and the visit is over. Opening pushes
   a history entry, popstate closes the lightbox, closing any other way pops the
   entry back off. `viaPop` stops close -> back() -> popstate -> close looping. */
(function () {
  'use strict';

  function qs(s, r) { return (r || document).querySelector(s); }
  function qsa(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }

  var CSS = ''
    + '.pf-zf-z{transform-origin:0 0;will-change:transform}'
    /* one slide = one screen, whatever the media aspect ratio is */
    + '.dialog-zoomed-gallery>.product-media-container{flex:0 0 100%!important;width:100%!important;max-width:100%!important;scroll-snap-align:start!important}'
    + '.dialog-zoomed-gallery .product-media-container--video .product-media{width:100%!important;max-width:100%!important}'
    + '.dialog-zoomed-gallery .product-media-container--video video,'
    + '.dialog-zoomed-gallery .product-media-container--video iframe,'
    + '.dialog-zoomed-gallery .product-media-container--video img{max-width:100%!important;max-height:100%!important;object-fit:contain!important}'
    + '.dialog-zoomed-gallery .product-media-container--video video{width:100%!important;height:100%!important;background:#000}'
    + '.pf-zx-deadposter{display:none!important}'
    /* close button: kill the blend, then a calm grey disc */
    + '.dialog-zoomed-gallery__dialog .dialog-zoomed-gallery__close-button{mix-blend-mode:normal!important;isolation:isolate!important;position:fixed!important;top:14px!important;right:14px!important;width:44px!important;height:44px!important;display:flex!important;align-items:center!important;justify-content:center!important;padding:0!important;border-radius:50%!important;background:#EDEDEA!important;color:#3A3A3A!important;border:1px solid rgba(0,0,0,.14)!important;box-shadow:0 2px 10px rgba(0,0,0,.16)!important;z-index:2147483000!important;cursor:pointer;transition:background .15s ease}'
    + '.dialog-zoomed-gallery__dialog .dialog-zoomed-gallery__close-button:hover{background:#E921E2!important}'
    + '.dialog-zoomed-gallery__dialog .dialog-zoomed-gallery__close-button svg{mix-blend-mode:normal!important;width:17px!important;height:17px!important;color:#3A3A3A!important;stroke:#3A3A3A!important;fill:none!important;stroke-width:2!important}'
    + '@media (max-width:749px){.dialog-zoomed-gallery__dialog .dialog-zoomed-gallery__close-button{top:10px!important;right:10px!important;width:42px!important;height:42px!important}}';

  function injectCss() {
    if (document.getElementById('pf-zx-css')) return;
    var st = document.createElement('style');
    st.id = 'pf-zx-css';
    st.textContent = CSS;
    (document.head || document.documentElement).appendChild(st);
  }

  function dialogEl() { return qs('.dialog-zoomed-gallery__dialog'); }
  function galleryEl() { var d = dialogEl(); return d ? qs('.dialog-zoomed-gallery', d) : null; }
  function isOpen() { var d = dialogEl(); return !!(d && d.hasAttribute('open')); }
  function slides() { var g = galleryEl(); return g ? qsa('.product-media-container', g) : []; }

  function indexOfView() {
    var g = galleryEl();
    if (!g) return 0;
    var w = g.clientWidth || 1;
    var n = slides().length;
    return Math.max(0, Math.min(n - 1, Math.round(g.scrollLeft / w)));
  }

  function currentImg() {
    var s = slides()[indexOfView()];
    return s ? qs('img', s) : null;
  }

  /* ---------------- video slides ---------------- */

  function activateVideo(slide) {
    if (!slide) return;
    if (String(slide.className).indexOf('--video') === -1) return;
    if (slide.getAttribute('data-pf-vid') === '1') return;
    slide.setAttribute('data-pf-vid', '1');

    var dm = slide.querySelector('deferred-media');
    try {
      if (dm && typeof dm.loadContent === 'function') dm.loadContent(false);
      else if (dm) { var b = dm.querySelector('button'); if (b) b.click(); }
    } catch (e) {}

    /* Muted, paused, with controls — never autoplay with sound. */
    setTimeout(function () {
      var v = slide.querySelector('video');
      if (v) {
        try {
          v.muted = true;
          v.setAttribute('playsinline', '');
          v.setAttribute('controls', '');
          v.pause();
        } catch (e) {}
      }
      /* The generated poster 404s on some products — do not leave a white box. */
      qsa('img', slide).forEach(function (im) {
        if (im.complete && im.naturalWidth === 0) im.classList.add('pf-zx-deadposter');
        else if (!im.complete) {
          im.addEventListener('error', function () { im.classList.add('pf-zx-deadposter'); });
        }
      });
    }, 400);
  }

  function activateCurrent() {
    var s = slides()[indexOfView()];
    activateVideo(s);
  }

  /* Inline + important — a stylesheet rule loses here. See header. */
  function lockGallery(on) {
    var g = galleryEl();
    if (!g) return;
    if (on) {
      g.style.setProperty('overflow', 'hidden', 'important');
      g.style.setProperty('touch-action', 'none', 'important');
      g.style.setProperty('scroll-snap-type', 'none', 'important');
      g.classList.add('pf-zf--zoomed');
    } else {
      g.style.removeProperty('overflow');
      g.style.removeProperty('touch-action');
      g.style.removeProperty('scroll-snap-type');
      g.classList.remove('pf-zf--zoomed');
    }
  }

  /* ---------------- zoom state ---------------- */

  var z = { scale: 1, x: 0, y: 0, img: null };

  function apply() {
    if (!z.img) { lockGallery(false); return; }
    if (z.scale > 1.01) {
      z.img.classList.add('pf-zf-z');
      z.img.style.transform = 'translate(' + z.x + 'px,' + z.y + 'px) scale(' + z.scale + ')';
      lockGallery(true);
    } else {
      z.img.style.transform = '';
      z.img.classList.remove('pf-zf-z');
      lockGallery(false);
    }
  }

  function reset(animate) {
    if (z.img) {
      if (animate) {
        var img = z.img;
        img.style.transition = 'transform .2s ease';
        setTimeout(function () { img.style.transition = ''; }, 220);
      }
      z.img.style.transform = '';
      z.img.classList.remove('pf-zf-z');
    }
    z.scale = 1; z.x = 0; z.y = 0; z.img = null;
    lockGallery(false);
  }

  function clamp() {
    if (!z.img) return;
    var bw = z.img.offsetWidth || 0;
    var bh = z.img.offsetHeight || 0;
    var minX = Math.min(0, bw - bw * z.scale);
    var minY = Math.min(0, bh - bh * z.scale);
    if (z.x > 0) z.x = 0;
    if (z.y > 0) z.y = 0;
    if (z.x < minX) z.x = minX;
    if (z.y < minY) z.y = minY;
  }

  function zoomAt(clientX, clientY, scale) {
    var img = z.img || currentImg();
    if (!img) return;
    var was = z.scale;
    var r = img.getBoundingClientRect();
    var px = (clientX - r.left + (was > 1 ? -z.x : 0)) / (was > 1 ? was : 1);
    var py = (clientY - r.top + (was > 1 ? -z.y : 0)) / (was > 1 ? was : 1);
    z.img = img;
    z.scale = scale;
    z.x = px * (1 - scale);
    z.y = py * (1 - scale);
    clamp();
    img.style.transition = 'transform .18s ease';
    setTimeout(function () { img.style.transition = ''; }, 200);
    apply();
  }

  function inGallery(e) {
    return !!(e.target && e.target.closest && e.target.closest('.dialog-zoomed-gallery'));
  }

  /* Never hijack the video's own controls. */
  function onVideo(e) {
    return !!(e.target && e.target.closest && e.target.closest('video, deferred-media, .product-media-container--video'));
  }

  /* ---------------- pointers ---------------- */

  var pts = {};
  var pinch = null;
  var pan = null;
  var lastTapT = 0, lastTapX = 0, lastTapY = 0, moved = false;

  function count() { var n = 0; for (var k in pts) if (pts.hasOwnProperty(k)) n++; return n; }
  function two() { var a = []; for (var k in pts) if (pts.hasOwnProperty(k)) a.push(pts[k]); return a; }

  document.addEventListener('pointerdown', function (e) {
    if (!isOpen() || !inGallery(e) || onVideo(e)) return;
    if (e.target.closest('.pf-zf__arrow, button')) return;
    pts[e.pointerId] = { x: e.clientX, y: e.clientY };
    moved = false;

    if (count() === 2) {
      var p = two();
      var dx = p[0].x - p[1].x, dy = p[0].y - p[1].y;
      pinch = {
        dist: Math.sqrt(dx * dx + dy * dy) || 1,
        scale: z.scale,
        cx: (p[0].x + p[1].x) / 2,
        cy: (p[0].y + p[1].y) / 2
      };
      z.img = z.img || currentImg();
      e.stopPropagation();
      return;
    }

    if (z.scale > 1.01) {
      pan = { x: e.clientX, y: e.clientY, ox: z.x, oy: z.y };
      e.stopPropagation();
    }
  }, true);

  document.addEventListener('pointermove', function (e) {
    if (!isOpen()) return;
    if (!pts[e.pointerId]) return;
    pts[e.pointerId] = { x: e.clientX, y: e.clientY };

    if (pinch && count() >= 2) {
      var p = two();
      var dx = p[0].x - p[1].x, dy = p[0].y - p[1].y;
      var d = Math.sqrt(dx * dx + dy * dy) || 1;
      var s = pinch.scale * (d / pinch.dist);
      if (s < 1) s = 1;
      if (s > 4) s = 4;
      zoomAt(pinch.cx, pinch.cy, s);
      moved = true;
      e.stopPropagation();
      return;
    }

    if (pan && z.scale > 1.01) {
      z.x = pan.ox + (e.clientX - pan.x);
      z.y = pan.oy + (e.clientY - pan.y);
      if (Math.abs(e.clientX - pan.x) > 4 || Math.abs(e.clientY - pan.y) > 4) moved = true;
      clamp();
      apply();
      e.stopPropagation();
    }
  }, true);

  function release(e) {
    if (!pts[e.pointerId]) return;
    delete pts[e.pointerId];

    if (count() < 2 && pinch) {
      pinch = null;
      if (z.scale <= 1.05) reset(true);
      if (isOpen()) e.stopPropagation();
      return;
    }
    if (pan) {
      pan = null;
      e.stopPropagation();
      return;
    }

    if (e.pointerType === 'touch' && !moved && isOpen() && inGallery(e) && !onVideo(e)) {
      var now = Date.now();
      var near = Math.abs(e.clientX - lastTapX) < 30 && Math.abs(e.clientY - lastTapY) < 30;
      if (now - lastTapT < 300 && near) {
        e.stopPropagation();
        e.preventDefault();
        if (z.scale > 1.01) reset(true); else zoomAt(e.clientX, e.clientY, 2.5);
        lastTapT = 0;
        return;
      }
      lastTapT = now; lastTapX = e.clientX; lastTapY = e.clientY;
    }
  }

  document.addEventListener('pointerup', release, true);
  document.addEventListener('pointercancel', release, true);

  document.addEventListener('dblclick', function (e) {
    if (!isOpen() || !inGallery(e) || onVideo(e)) return;
    e.preventDefault();
    e.stopPropagation();
    if (z.scale > 1.01) reset(true); else zoomAt(e.clientX, e.clientY, 2.5);
  }, true);

  document.addEventListener('click', function (e) {
    if (!isOpen() || !inGallery(e)) return;
    if (onVideo(e)) { e.stopPropagation(); return; }
    if (z.scale > 1.01 || moved) { e.stopPropagation(); moved = false; }
  }, true);

  /* ---------------- arrow keys ---------------- */

  document.addEventListener('keydown', function (e) {
    if (!isOpen()) return;
    if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
    var g = galleryEl();
    if (!g) return;
    e.preventDefault();
    e.stopPropagation();
    reset(false);
    var n = slides().length;
    var w = g.clientWidth || 1;
    var i = indexOfView() + (e.key === 'ArrowRight' ? 1 : -1);
    if (i < 0) i = 0;
    if (i > n - 1) i = n - 1;
    g.scrollLeft = i * w;
    setTimeout(activateCurrent, 120);
  }, true);

  /* ---------------- back button closes the lightbox ---------------- */

  var pushed = false;
  var viaPop = false;

  function opened() {
    injectCss();
    setTimeout(activateCurrent, 200);
    if (pushed) return;
    try { history.pushState({ pfLightbox: 1 }, ''); pushed = true; } catch (e) {}
  }

  function closed() {
    reset(false);
    qsa('.dialog-zoomed-gallery video').forEach(function (v) { try { v.pause(); } catch (e) {} });
    var hadPush = pushed;
    pushed = false;
    if (hadPush && !viaPop) {
      try { history.back(); } catch (e) {}
    }
    viaPop = false;
  }

  window.addEventListener('popstate', function () {
    if (!isOpen()) return;
    viaPop = true;
    pushed = false;
    var d = dialogEl();
    var zd = d && d.closest ? d.closest('zoom-dialog') : null;
    try { if (zd && typeof zd.close === 'function') zd.close(); } catch (e) {}
    setTimeout(function () {
      if (d && d.hasAttribute('open')) { try { d.close(); } catch (e) {} }
    }, 60);
  });

  function watchScroll(g) {
    if (!g || g.getAttribute('data-pf-zx-scroll') === '1') return;
    g.setAttribute('data-pf-zx-scroll', '1');
    var last = indexOfView();
    g.addEventListener('scroll', function () {
      var i = indexOfView();
      if (i !== last) {
        last = i;
        if (z.scale > 1.01) reset(false);
        activateCurrent();
      }
    }, { passive: true });
  }

  function watchDialog() {
    var d = dialogEl();
    if (!d || d.getAttribute('data-pf-zx') === '1') return;
    d.setAttribute('data-pf-zx', '1');
    try {
      new MutationObserver(function () {
        if (d.hasAttribute('open')) { opened(); watchScroll(galleryEl()); }
        else closed();
      }).observe(d, { attributes: true, attributeFilter: ['open'] });
    } catch (e) {}
    if (d.hasAttribute('open')) { opened(); watchScroll(galleryEl()); }
  }

  injectCss();
  watchDialog();
  var tries = 0;
  var iv = setInterval(function () {
    watchDialog();
    if (++tries > 60) clearInterval(iv);
  }, 400);
})();